module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_17.0f532c4b.png";